//
import Main from '@/views/Main'
import { ModuleLayout } from '@/components/reusable_components/next'

//
import ProviderMain from '@/views/provider/ProviderMainTabs'
import providerProductShow from '@/views/provider/ProviderProductsShow'
import ProviderCreate from '@/views/provider/ProviderCreate'

//
import ProviderListView from '@/views/Purchase/PchProvider/list'

//
export default {
    path: 'providers',
    component: ModuleLayout,
    meta: {
        title: 'Proveedores',
    },
    children: [
        {
            path: '',
            name: 'provider-list',
            component: ProviderListView,
        },
        {
            path: 'create',
            name: 'provider-create',
            component: ProviderCreate,
            meta: {
                title: 'Crear proveedor',
            },
        },
        {
            path: ':id',
            component: Main,
            meta: {
                title: 'Detalles del proveedor',
            },
            children: [
                {
                    path: '',
                    name: 'provider-update',
                    component: ProviderMain,
                },
                {
                    path: 'product/:productId',
                    name: 'provider-product',
                    component: providerProductShow,
                    meta: {
                        title: 'Detalle producto',
                    },
                },
            ],
        },
    ],
}
